<p>{{potato.name}}</p>
